module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_3_01-7c9b2c83cfd41bd5b9fcaaa1dc4f1b3c.jpg";